export default __webpack_public_path__ + "static/media/rectangle1.b3bfc2cd.svg";